module.exports = __webpack_public_path__ + "support.5cda1d04.jpg";